import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages/pages.component';
import { PageComponent } from './page/page.component';
import { CmsRoutingModule } from './cms-routing.module';
import { SnippetAddComponent } from './snippet-add/snippet-add.component';
import { SnippetCallToActionComponent } from './snippet-call-to-action/snippet-call-to-action.component';
import { SnippetEditComponent } from './snippet-edit/snippet-edit.component';
import { SnippetPluginComponent } from './snippet-plugin/snippet-plugin.component';
import { SnippetSortationComponent } from './snippet-sortation/snippet-sortation.component';
import { SnippetWysiwygComponent } from './snippet-wysiwyg/snippet-wysiwyg.component';
import { SnippetVideoComponent } from './snippet-video/snippet-video.component';
import { MenusComponent } from './menus/menus.component';
import { ImagesComponent } from './images/images.component';
import { ImageCropperComponent } from './images/image-cropper/image-cropper.component';
import { ImageDeleteComponent } from './images/image-delete/image-delete.component';
import { ImageUploadComponent } from './images/image-upload/image-upload.component';
import { SnippetImageComponent } from './snippet-image/snippet-image.component';
import { EditMenuComponent } from './edit-menu/edit-menu.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DragulaModule } from 'ng2-dragula';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FaqModule } from '../faq/faq.module';
import { SnippetGridComponent } from './snippet-grid/snippet-grid.component';
import { GalleriesComponent } from './galleries/galleries.component';
import { GalleryManageComponent } from './gallery-manage/gallery-manage.component';
import { GalleryImageManageComponent } from './gallery-image-manage/gallery-image-manage.component';
import { SnippetGalleryComponent } from './snippet-gallery/snippet-gallery.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from '../pipes/pipes.module';
import { UserPhotoSubmissionsComponent } from './user-photo-submissions/user-photo-submissions.component';
import { PhotoViewerComponent } from './user-photo-submissions/photo-viewer/photo-viewer.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
    declarations: [
        PagesComponent,
        PageComponent,
        SnippetAddComponent,
        SnippetCallToActionComponent,
        SnippetEditComponent,
        SnippetPluginComponent,
        SnippetSortationComponent,
        SnippetWysiwygComponent,
        SnippetVideoComponent,
        SnippetPluginComponent,
        SnippetImageComponent,
        MenusComponent,
        ImagesComponent,
        ImageCropperComponent,
        ImageDeleteComponent,
        ImageUploadComponent,
        EditMenuComponent,
        SnippetGridComponent,
        GalleriesComponent,
        GalleryManageComponent,
        GalleryImageManageComponent,
        SnippetGalleryComponent,
        UserPhotoSubmissionsComponent,
        PhotoViewerComponent,
    ],
    exports: [ImagesComponent],
    imports: [
        CmsRoutingModule,
        EditorModule,
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AngularCropperjsModule,
        DropzoneModule,
        DragulaModule.forRoot(),
        FaqModule,
        NgSelectModule,
        PipesModule,
        AngularSvgIconModule,
    ],
})
export class CmsModule {}
